import { createRouter, createWebHashHistory } from 'vue-router';
import router from '@/router'
import staticRouter from './staticRouter'//静态路由

export default () => {
  router.clearRoutes();
  staticRouter.forEach(route => {
    router.addRoute(route);
  })
  // router.getRoutes().forEach((route)=>{
  //   route.name && router.removeRoute(route.name);
  // })
  // const newRouter = createRouter({
  //   history: createWebHashHistory(),
  //   routes: staticRouter
  // });
  // router.matcher = newRouter.matcher;
}